// Display formatting shared by every record view. Full values stay available via title/copy.

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

/** A UUID reads as its first and last four characters; other identifiers pass through. */
export function shortId(id: string) {
  return UUID.test(id) ? `${id.slice(0, 4)}…${id.slice(-4)}` : id;
}

const dateTime = new Intl.DateTimeFormat(undefined, {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
  hour: '2-digit',
  minute: '2-digit',
});
const date = new Intl.DateTimeFormat(undefined, {
  day: 'numeric',
  month: 'short',
  year: 'numeric',
});

/** "17 Oct 2026, 13:51" in the viewer's locale and time zone; unparseable input is shown as is. */
export function formatDateTime(iso: string | undefined | null) {
  if (!iso) return '';
  const value = new Date(iso);
  return Number.isNaN(value.getTime()) ? iso : dateTime.format(value);
}

export function formatDate(iso: string | undefined | null) {
  if (!iso) return '';
  const value = new Date(iso);
  return Number.isNaN(value.getTime()) ? iso : date.format(value);
}

/** Up to two initials for an avatar: "Mara Owner" → "MO"; an email gives its first letter. */
export function initials(name: string) {
  const words = name.includes('@') ? [name] : name.split(/\s+/).filter(Boolean);
  const picked = words.length > 1 ? [words[0], words[words.length - 1]] : words.slice(0, 1);
  return (
    picked
      .map((word) => word?.[0] ?? '')
      .join('')
      .toUpperCase() || '?'
  );
}
